var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrivalsPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 76,
  height: 62,
  viewBox: "0 0 76 62"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#69728B",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  stroke: "#69728B",
  strokeWidth: 0.5,
  d: "M7.795 4A.794.794 0 0 0 7 4.793v15.86c0 1.13.528 2.143 1.341 2.924.802.769 1.88 1.337 3.13 1.759v.025l16.891 6.591L8.938 45.383c-.47.322-.38 1.173.149 1.388l7.948 3.172a.8.8 0 0 0 .596 0L45.974 38.94l16.369 6.245h.025c1.335.555 2.46.843 3.453.843a3.12 3.12 0 0 0 2.36-1.041A3.26 3.26 0 0 0 69 42.856c0-3.192-1.608-7.703-5.962-10.21a1 1 0 0 0-.124-.05l-15.847-5.823-9.191-15.265a.8.8 0 0 0-.323-.297l-9.539-4.758a.8.8 0 0 0-.372-.099 1 1 0 0 0-.15.025.795.795 0 0 0-.546 1.09s3.452 8.16 5.639 14.001l-14.606-5.377-2.26-7.558a.8.8 0 0 0-.373-.471s-6.878-3.771-7.08-3.915A.82.82 0 0 0 7.796 4zm.795 2.156 5.688 3.147 2.285 7.608a.8.8 0 0 0 .497.52l45.184 16.603c3.778 2.176 5.166 6.17 5.166 8.822 0 .347-.155.761-.422 1.065-.268.304-.614.52-1.167.52-.676 0-1.654-.23-2.882-.743q-.008 0-16.717-6.344a.8.8 0 0 0-.571 0L17.333 48.332 11.05 45.83 30.5 32.4c.47-.323.378-1.173-.15-1.388l-18.282-7.137c-1.16-.37-2.055-.882-2.633-1.437-.578-.556-.844-1.122-.844-1.785V6.156zm20.567 2.627 7.502 3.741 8.023 13.382-10.135-3.717c-1.846-5.099-4.59-11.522-5.39-13.406z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 2,
  x: 6,
  y: 55,
  rx: 1
}))));
export default SvgArrivalsPlaceholder;